/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
/**
 * Checks if the input matches the schema. By using a type predicate, this
 * function can be used as a type guard.
 *
 * @template TSchema The type of the Zod schema.
 *
 * @param {TSchema} schema The schema to be used.
 * @returns {function(input: unknown): input is z.output<TSchema>} A function that takes an input and returns whether the input matches the schema.
 */
var isType = function isType(schema) {
  return function (input) {
    return schema.safeParse(input).success;
  };
};

export { isType };
//# sourceMappingURL=is-type.js.map
